import { CorrectOrIncorrect } from "@common";

export const getButtonPalletFromCorrectOrIncorrect = (
  showCorrect: boolean,
  correctOrIncorrect: CorrectOrIncorrect
) => {
  if (showCorrect && correctOrIncorrect === "correct") {
    return "green";
  } else if (showCorrect && correctOrIncorrect === "incorrect") {
    return "red";
  } else {
    return undefined;
  }
};
